import { SelectedDimensions } from '../types'

export const getDimensionsFilterList = (
  selectedDimensions: SelectedDimensions,
) => {
  const keys = Object.keys(selectedDimensions)
  if (keys.length === 0) {
    return null
  }

  const dimensionFilters: {
    dimensionParameterID: string
    dimensionName: string
    dimensionOptions: string[]
  }[] = []

  keys.forEach((key) => {
    if (selectedDimensions[key].dimensionOptions.length > 0) {
      dimensionFilters.push({
        dimensionParameterID: selectedDimensions[key].dimensionParameterID,
        dimensionName: key,
        dimensionOptions: [...selectedDimensions[key].dimensionOptions],
      })
    }
  })

  return {
    dimensionFilters,
  }
}
